import React from 'react';
import {useEffect,useState} from 'react'
import axios from 'axios';
import loginSvg from '../../Assets/login.svg'
import locksvg from '../../Assets/lock.png'
import emailErrorsvg from '../../Assets/email_error.png'
import emailsvg from '../../Assets/email.png'
import lock_error from '../../Assets/lock_error.png'
import logo from '../../Assets/logo.svg'

import './Login.css'
import {login} from '../../Redux/Reducer/userReducer'
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux"
import { useSelector } from 'react-redux'
import { selectUser } from '../../Redux/Reducer/userReducer';
import  {ManualLogin,googleLogin}  from '../../services/loginServices';
import Group from '../../Assets/Group.png'
import googleLogo from '../../Assets/googlelogo.png'
import { setLogin } from '../../Redux/Actions';
import { GoogleLogin } from '@react-oauth/google';

import { useGoogleLogin } from '@react-oauth/google';
// forgotPassword=false;
// success = "";
// failure = false;

export default function Login(props) {
	let failure=false
	let loggedIn=false
	let token
	let userId
	let activeRole
	let obj
	const [email, setEmail] = useState();
	const [password, setPassword] = useState();
	const navigate = useNavigate();
	const flag = useSelector(state => state.userReducer);

	const dispatch=useDispatch();
	const [credCheck, setcredCheck] = useState(false);
	let error = "Invalid username or password. Please try again"

	const AppLogin = async (e) => {
		e.preventDefault();
	
		try {
		//   let x = ManualLogin({ email }, { password });
		  let x=ManualLogin({email}.email,{password}.password)
		  let myData = await x;
	
		  if (myData.login == null) {
			setcredCheck(true);
			console.log("credCheck should be true now", credCheck); // This logs before state updates
		  } else {
			setcredCheck(false);
			navigate('/Chat');
	
			let obj = {
			  token: myData.login.token,
			  activeRole: myData.login.user.activeRole,
			  userId: myData.login.user.id,
			  name: myData.login.user.firstName,
			  email: email,
			  lastName: myData.login.user.lastName,
			};
	
			localStorage.setItem('token', obj.token);
			localStorage.setItem('userId', obj.userId);
			localStorage.setItem('role', obj.activeRole);
			localStorage.setItem('email', obj.email);
			localStorage.setItem('name', obj.name);
			localStorage.setItem('lastName', obj.lastName);
			dispatch(setLogin(obj));
		  }
		} catch (error) {
		  console.error("Login error:", error);
		  setcredCheck(true); // Handle errors gracefully and update state
		}
	  };
	
	  useEffect(() => {
		if (credCheck) {
		  console.log("credCheck is true, displaying error message.");
		}
	  }, [credCheck]);

	const login = useGoogleLogin({
		onSuccess: async (tokenResponse) => {
			console.log("tokenResponse",tokenResponse);
			
			try {
				// Call googleLogin function
				let result = await googleLogin(tokenResponse.access_token);
				
				// Navigate to '/Chat'
				if (result.googleLogin == null) {
					setcredCheck(true);
					console.log("credCheck should be true now", credCheck); // This logs before state updates
				  } 

				  else{
					setcredCheck(false);
					navigate('/Chat');
				
					let user = result.googleLogin;
					console.log("user", user);
					
					// Store user details in localStorage
					localStorage.setItem('token', user.token);
					localStorage.setItem('userId', user.user.id);
					localStorage.setItem('role', user.user.activeRole);
					localStorage.setItem('email', user.user.email);
					localStorage.setItem('name', user.user.firstName);
					localStorage.setItem('lastName', user.user.lastName);
					localStorage.setItem('rolesAllowed', user.user.roles);
				  }
				
			} catch (error) {
				// Handle any errors
				setcredCheck(true);
				console.error("Login failed:", error);
				// Optionally, you can display an error message to the user here
			}
		}
	});
	
	
	
  return (
    <>
			
			{credCheck && (
        <div className="error-box">
          Invalid username or password. Please try again.
        </div>
      )}
			<form onSubmit={(e) => AppLogin(e)} style={{ display: 'inline-block' }}>
     
			<img src={logo} className='logo' alt="Logo" />
			<div className='title'>Welcome Back!</div>

			<div style={{ paddingTop: '12%' }}>
				<input
					className='cred_Button'
					type='email'
					placeholder='Username or Email Id'
					value={email}
					onChange={e => setEmail(e.target.value)}
				/>
			</div>


			<div style={{ paddingTop: '4%' }}>
				<input
				className='cred_Button'
				type='password'
				placeholder='Password'
				value={password}
				onChange={e => setPassword(e.target.value)}
				/>
			</div>

			<div style={{ paddingTop: '1.875rem' }}>
				<button type='submit' className='login_button'>
				<span className='continueText'>Continue</span>
				</button>
			</div>

			<div style={{ marginLeft: 'auto', paddingTop: '3.5%', display: 'inline-flex', marginTop: '1rem' }}>
				<hr />
				<div className='divider_left'></div>
				<div>OR</div>
				<div className='divider_right'></div>
			</div>
			</form>

				<div style={{marginTop:'0rem'}}>
				<div className='google_signin' onClick={() => login()}>
					<img src={googleLogo} style={{width: '1.5rem',height: '1.494rem',float: 'left'}}/>
					<span className='google_text'>Continue with Google</span>
				</div>
				</div>
						
    </>
  )
}